$(() => {
	var url: string = <any>$('#noticia-full-url').val();
	$('#noticia-full-url').remove();

	$('#print_button').click(function() {
		(<any>$('div.PrintArea')).printArea({ mode: 'iframe', extraCss: '/public/css/site/print.css' });
	});

	$('#fontA_button').click(function() {
		var tamanhoFonte = $('.noticia-info').css('font-size');
		var tf = parseFloat(tamanhoFonte);
		if (tf < 29) {
			$('.noticia-info').css({ 'font-size': tf + 5 });
		}
	});

	$('#fontD_button').click(function() {
		var tamanhoFonte = $('.noticia-info').css('font-size');
		var tf = parseFloat(tamanhoFonte);
		if (tf > 14) {
			$('.noticia-info').css({ 'font-size': tf - 5 });
		}
	});

	$('#textB_button').click(function() {
		var backG = $('.noticia-info').css('background-color');
		if (backG == 'rgb(0, 0, 0)') {
			$('.noticia-info').css({ 'background-color': '#fff' });
			$('.noticia-info').css({ color: '#333' });
		} else {
			$('.noticia-info').css({ color: 'yellow' });
			$('.noticia-info').css({ 'background-color': '#000' });
		}
	});

	$('.noticia-social-btn.fb').click(() => {
		window.open(
			'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
			'',
			'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
		);
	});

	$('.noticia-social-btn.tw').click(() => {
		window.open(
			'http://twitter.com/share?url=' + encodeURIComponent(url),
			'',
			'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
		);
	});
});
